import { __decorate } from "tslib";
import { html, observable } from '@microsoft/fast-element';
import { FoundationElement } from '@microsoft/fast-foundation';
import { convertToKebabCase } from '../grid-pro';
import { GridProRendererTypes } from '../grid-pro.types';
/**
 * The Actions Menu Renderer element.
 * @remarks For multiple actions scenarios.
 * @public
 * @tagname %%prefix%%-grid-pro-actions-menu-renderer
 */
export class ActionsMenuRenderer extends FoundationElement {
    init(params) {
        if (!params)
            return;
        this.params = params;
    }
    getGui() {
        return this;
    }
    refresh(params) {
        return false;
    }
}
__decorate([
    observable
], ActionsMenuRenderer.prototype, "params", void 0);
/**
 * A function that returns a Foundation Actions Menu for configuring the component with a DesignSystem.
 *
 * @public
 * @remarks
 * HTML Element: \<foundation-grid-pro-actions-menu-renderer\>
 */
export const foundationGridProActionsMenuRenderer = ActionsMenuRenderer.compose({
    baseName: 'grid-pro-actions-menu-renderer',
    template: html `
    <foundation-actions-menu
      name="${(x) => x.params.headerName}"
      :definition=${(x) => x.params}
    ></foundation-actions-menu>
  `,
});
/**
 * Helper function to get ColDef {@link https://www.ag-grid.com/javascript-data-grid/column-properties/} for Actions Menu Renderer.
 * Will take the parameter values for a base ColDef and merge them with the overrideDef (if specified).
 * @param actions - Array of {@link @genesislcap/foundation-ui#ActionMenuItem} to be displayed in the menu.
 * @param overrideDef - Optional override for the ColDef. Will override any of the default values. Default is an empty object.
 * @param customActionsOpenerName - Optional custom name for the button that opens the menu. Default is '⋮'.
 * @param isVertical - Optional flag to display the menu vertically. Default is false (displays the menu horizontally, follow the rowHeight).
 * @param buttonAppearance - Optional appearance for the button that opens the menu. Default is 'outline'.
 * @returns Merged ColDef (base ColDef created from the parameters + overrideDef) for Actions Menu Renderer.
 * @example
 * ```ts
 * public exampleActionsMenuDef: ColDef = getActionsMenuDef(
 *  [
 *    {
 *      name: 'View',
 *      callback: (rowData) => logger.debug('VIEWW!!!', rowData),
 *    },
 *      {
 *      name: 'Delete',
 *      callback: (rowData) => logger.debug('DELETE!!!', rowData),
 *    },
 *  ],
 *  {
 *    headerName: 'Instrument Actions',
 *    width: 180,
 *  },
 *  '+',
 *  true,
 *  'primary-gradient'
 * );
 * ```
 * @public
 */
export const getActionsMenuDef = (actions, overrideDef = {}, customActionsOpenerName = '⋮', isVertical = false, buttonAppearance) => {
    const actionsMenuDef = {
        cellRenderer: GridProRendererTypes.actionsMenu,
        cellRendererParams: {
            actions,
            buttonAppearance,
            isVertical,
            buttonText: customActionsOpenerName,
        },
        cellStyle: { border: 'none', overflow: 'visible' },
        field: `${convertToKebabCase(overrideDef.headerName) || 'actions-menu'}`,
        headerName: 'Actions',
        // valueGetter: (params: ValueGetterParams) => {
        //   params.data.actions = actions;
        //   params.data.buttonText = customActionsOpenerName;
        //   return null;
        // },
        width: 150,
    };
    return Object.assign(Object.assign({}, actionsMenuDef), overrideDef);
};
